import { useEffect } from "react";
import { useDispatch } from "react-redux";

export default function ThemeInitializer() {
  const dispatch = useDispatch();

  useEffect(() => {
    const applyTheme = () => {
      const savedTheme = localStorage.getItem("themeType");
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

      const theme =
        savedTheme === "1"
          ? "dark"
          : savedTheme === "0"
          ? "light"
          : prefersDark
          ? "dark"
          : "light";

      document.body.setAttribute("data-theme", theme);
    };

    // Initial setup
    applyTheme();

    // Redux defaults
    dispatch({ type: "ADV", payload: localStorage.getItem("adv") || 1 });
    dispatch({ type: "MODE", payload: localStorage.getItem("mode") || 0 });

    // Font setup
    const fontSize = localStorage.getItem("Font");
    const root = document.documentElement;
    const appliedFontSize = fontSize || "13";
    if (!fontSize) localStorage.setItem("Font", appliedFontSize);
    root.style.setProperty("--large", `${appliedFontSize}px`);

    // React to system theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleThemeChange = (e) => {
      const userTheme = localStorage.getItem("themeType");
      if (!userTheme) {
        document.body.setAttribute("data-theme", e.matches ? "dark" : "light");
      }
    };

    mediaQuery.addEventListener("change", handleThemeChange);
    return () => mediaQuery.removeEventListener("change", handleThemeChange);
  }, [dispatch]);

  return null;
}
